'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DispatchWarning = function (_Component) {
    (0, _inherits3.default)(DispatchWarning, _Component);

    function DispatchWarning() {
        (0, _classCallCheck3.default)(this, DispatchWarning);
        return (0, _possibleConstructorReturn3.default)(this, (DispatchWarning.__proto__ || (0, _getPrototypeOf2.default)(DispatchWarning)).apply(this, arguments));
    }

    (0, _createClass3.default)(DispatchWarning, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                minPriceForDispatch = _props.minPriceForDispatch,
                processingOrdersPrice = _props.processingOrdersPrice;

            var backloggSummary1 = (0, _localize2.default)("App:BacklogOfOrdersSummary_FirstPart");
            var backloggSummary2 = (0, _localize2.default)("App:BacklogOfOrdersSummary_SecondPart");

            var processingPriceBlock = backloggSummary1.length + backloggSummary2.length > 0 ? _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    backloggSummary1,
                    ' ',
                    backloggSummary2,
                    ' ',
                    (0, _linksoftAlbatros.formatPrice)(processingOrdersPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                )
            ) : '';

            if (minPriceForDispatch > 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('hr', { className: 'hidden-md' }),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            (0, _localize2.default)("App:YourLimitForExpedition"),
                            ' ',
                            (0, _linksoftAlbatros.formatPrice)(minPriceForDispatch, _linksoftAlbatros.PriceType.CartTotalPrice),
                            ' ',
                            (0, _localize2.default)("App:WithoutVat"),
                            ' (',
                            (0, _localize2.default)("App:LimitForExpeditionIsNotDependentOnSize"),
                            ').'
                        )
                    ),
                    processingPriceBlock
                );
            }
            return null;
        }
    }]);
    return DispatchWarning;
}(_react.Component);

DispatchWarning.propTypes = {
    minPriceForDispatch: _propTypes2.default.number,
    processingOrdersPrice: _propTypes2.default.number
};

function mapStateToProps(state, ownProps) {
    return {
        minPriceForDispatch: state.cart.minPriceForDispatch,
        processingOrdersPrice: state.cart.processingOrdersPrice
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DispatchWarning);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/DispatchWarning.js
// module id = 904
// module chunks = 0